const coinbaseEscrowFlowVersion = (state = false, action) => {
  switch (action.type) {
      case 'SET_COINBASE_ESCROW_FLOW_VERSION':
          return action.version
      default:
          return state
  }
}

export default coinbaseEscrowFlowVersion;